export * from './EmptyLegToRemove';
export var ResourceType;
(function (ResourceType) {
    ResourceType["pilot"] = "pilot";
    ResourceType["aircraft"] = "aircraft";
    ResourceType["employee"] = "employee";
    ResourceType["customer"] = "customer";
    ResourceType["classroom"] = "classroom";
    ResourceType["flightsimulator"] = "flightsimulator";
})(ResourceType || (ResourceType = {}));
export var ResourceRole;
(function (ResourceRole) {
    ResourceRole["aircraft"] = "aircraft";
    ResourceRole["pic"] = "pic";
    ResourceRole["fo"] = "fo";
    ResourceRole["person"] = "person";
    ResourceRole["classroom"] = "classroom";
    ResourceRole["flightsimulator"] = "flightsimulator";
})(ResourceRole || (ResourceRole = {}));
export var EventType;
(function (EventType) {
    EventType["owner_flight"] = "owner_flight";
    EventType["charter_flight"] = "charter_flight";
    EventType["training_flight"] = "training_flight";
    EventType["rental_flight"] = "rental_flight";
    EventType["ferry_flight"] = "ferry_flight";
    EventType["maintenance_aog"] = "maintenance_aog";
    EventType["training"] = "training";
    EventType["day_off"] = "day_off";
    EventType["requested_day_off"] = "requested_day_off";
    EventType["standby"] = "standby";
    EventType["travel"] = "travel";
    EventType["office"] = "office";
    EventType["home_office"] = "home_office";
    EventType["other"] = "other";
    EventType["leg"] = "leg";
    EventType["wet_lease_flight"] = "wet_lease_flight";
})(EventType || (EventType = {}));
export var TravelMethod;
(function (TravelMethod) {
    TravelMethod["airline"] = "airline";
    TravelMethod["train"] = "train";
    TravelMethod["bus"] = "bus";
    TravelMethod["taxi"] = "taxi";
})(TravelMethod || (TravelMethod = {}));
export var Permission;
(function (Permission) {
    Permission["read_detail"] = "read_detail";
    Permission["crew_edit_own"] = "crew_edit_own";
    Permission["read_preview"] = "read_preview";
    Permission["read_only"] = "read_only";
})(Permission || (Permission = {}));
export var EventAttributes;
(function (EventAttributes) {
    EventAttributes["generated_empty_leg"] = "generated_empty_leg";
    EventAttributes["overlapping_with_existing"] = "overlapping_with_existing";
})(EventAttributes || (EventAttributes = {}));
//# sourceMappingURL=index.js.map